import React, { useEffect } from "react";

import { bool, func } from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { push } from "react-router-redux";
import { actions as layoutActions } from "reducers/layout";
import { actions as tokenActions } from "reducers/token";

import Head from "pages/_components/Head";
import { resizableRoute } from "pages/_components/Resizable";
import { dispatchV3ShellLayout, isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";

import * as i18n from "util/i18n";

import { Box, Button, Icon, Hint, Text } from "@ui-kit/components/index.es";

function TokenSeedError(props) {
    TokenSeedError.propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    TokenSeedError.defaultProps = {
        embeddedInV3Shell: false,
    };

    const { dispatch, isDesktop, embeddedInV3Shell } = props;

    const handleBack = () => dispatch(push("/desktop"));

    useEffect(() => {
        dispatch(tokenActions.tokenSeedErrorRecoveryFinished());
        if (!embeddedInV3Shell || !isUxDashboardImprovementsEnabled()) {
            return undefined;
        }
        dispatchV3ShellLayout(dispatch, {
            titleKey: "settings.tokenPassword",
            goBackPath: "/settings/token",
            rightContentMobile: null,
            scopes: ["settings"],
        });
        return () => {
            dispatch(layoutActions.setScopes([]));
            dispatch(layoutActions.setTitleKey(""));
            dispatch(layoutActions.setHeaderTitle(""));
            dispatch(layoutActions.setHeaderSubtitle(""));
            dispatch(layoutActions.setGoBackPath(null));
            dispatch(layoutActions.setRightContentMobile(null));
        };
    }, [dispatch, embeddedInV3Shell]);

    const isShellActive = embeddedInV3Shell && isUxDashboardImprovementsEnabled();

    return (
        <Box mx={24} column align="center" className="admin-detail-head z-index-1 px-0">
            {(isDesktop || !isShellActive) && (
                <Head
                    onBack={handleBack}
                    headerClassName="blue-main-header-mobile"
                    centerElement={() => (
                        <Text as="subtitle" className="m-0 no-wrap text-white font-medium">
                            {i18n.get("settings.tokenPassword")}
                        </Text>
                    )}
                    accessibilityTextId="settings.tokenPassword"
                />
            )}
            <Text align="center" variant="body" className="mt-4">
                {i18n.get("setting.token.seed.error.title")}
            </Text>
            <Icon color="error-border-color" id="UserDefault" name="ShieldCancel" size={80} variant="fill" />
            <Hint size="big" text={i18n.get("setting.token.seed.error.hint")} />
            <Button
                className="w-100"
                icon="ArrowRight"
                iconVariant="outline"
                size="large"
                text={i18n.get("setting.token.seed.error.btn")}
                onClick={() => {
                    dispatch(push("/settings/token"));
                }}
            />
        </Box>
    );
}

export default compose(connect(), resizableRoute)(TokenSeedError);
